import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  create(params) {
    const url = apiRoutes.apiV1NotificationsPath();

    return FetchHelpers.post(url, params);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/NotificationRepository.js